const { Component } = React;

export default class Calendar extends Component {
  setPopup(e, calendarKey, checkIn, checkOuts) {
    const calendar = document.getElementsByClassName(calendarKey)[0];
    const calendarLeft = calendar.getBoundingClientRect().left;
    const checkInBoxPosition = $(e.target).offset();

    this.props.setPopup(calendarKey, checkIn, checkOuts, calendarLeft, checkInBoxPosition.left + 20, checkInBoxPosition.top, this.props.rstCode);
  }

  getOffset = (el) => {
    let element = el;
    let _x = 0;
    let _y = 0;

    while( element && !isNaN( element.offsetLeft ) && !isNaN( element.offsetTop ) ) {
      _x += element.offsetLeft - element.scrollLeft;
      _y += element.offsetTop - element.scrollTop;
      element = element.offsetParent;
    }

    return { top: _y, left: _x };
  }

  getMonth() {
    const jsxCalendar = [];

    for (let firstDayWeek = 0; firstDayWeek < this.props.calendar.length; firstDayWeek += 7) {
      jsxCalendar.push(this.getWeek(firstDayWeek));
    }

    return <tbody>{jsxCalendar}</tbody>;
  }

  getWeek(firstDayWeek) {
    const week = [];

    for (let day = 0; day < 7; day++) {
      week.push(this.getDay(this.props.calendar[day + firstDayWeek], firstDayWeek + day - this.props.firstDayOfMonth + 1));
    }

    return <tr key={firstDayWeek}>{week}</tr>;
  }

  getDay({ type, checkIn, checkOuts }, date) {
    const day = {
      'blank':
                <td key={date}/>,
      'number':
                <td key={date}>{date}</td>,
      'checkIn':
                <td key={date} className="remove-padding">
                  <a
                    className="check-in-date"
                    onClick={(e) => this.setPopup(e, this.props.calendarKey, checkIn, checkOuts)}
                  >
                    {date}
                  </a>
                </td>,
      'rest':
                <td key={date} className="remove-padding">
                  <span className="rest-of-date">
                    {date}
                  </span>
                </td>
    };

    return day[type];
  }

  render() {
    const { monthName, year } = this.props;

    return (
      <div className={`slider-calendar-item ${this.props.calendarKey}`}>
        <table className="calendars calendar1 js-list-grid-viewer-viewport">
          <thead>
            <tr>
              <td className="month" colSpan="4">
                {monthName.substring(0, 3)}
              </td>
              <td className="year" colSpan="3">
                {year}
              </td>
            </tr>
            <tr className="days">
              <td>SUN</td>
              <td>MON</td>
              <td>TUE</td>
              <td>WED</td>
              <td>THU</td>
              <td>FRI</td>
              <td>SAT</td>
            </tr>
          </thead>
          {this.getMonth()}
        </table>
      </div>
    );
  }
}
